import axios from "axios"
import { AUTH_ENDPOINTS } from "./endpoints"
import { LoginDataType, SetupAccountDataType, VerifyMfaDataType } from "../types"

export const getCoordinates = (): Promise<string> => {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve("");
      return;
    }
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => resolve(`${coords.latitude},${coords.longitude}`),
      () => resolve("")
    );
  });
};

export const loginService = async (data: LoginDataType) => {
  const { longitude, latitude, ...rest } = data
  try {
    const response = await axios.post(AUTH_ENDPOINTS.LOGIN, rest, {
      headers: {
        ...(longitude && { "Longitude": longitude }),
        ...(latitude && { "Latitude": latitude }),
      },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const verifyMfaService = async (data: VerifyMfaDataType) => {
  try {
    const { longitude, latitude, ...rest } = data
    const response = await axios.post(AUTH_ENDPOINTS.VERIFY_MFA, rest, {
      headers: {
        ...(longitude && { "Longitude": longitude }),
        ...(latitude && { "Latitude": latitude }),
      },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const verifyMfaBackupCodeService = async (data: VerifyMfaDataType) => {
  try {
    const response = await axios.post(AUTH_ENDPOINTS.VERIFY_MFA_BACKUP_CODE, data)
    return response.data
  } catch (error) {
    throw error
  }
}

export const setupAccountService = async (data: SetupAccountDataType) => {
  try {
    const { longitude, latitude, ...rest } = data
    const response = await axios.post(AUTH_ENDPOINTS.SETUP_ACCOUNT, rest, {
      headers: {
        ...(longitude && { "Longitude": longitude }),
        ...(latitude && { "Latitude": latitude }),
      },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getTwoFactorSecretDetails = async () => {
  try {
    const response = await axios.get(AUTH_ENDPOINTS.GET_2FA_SECRET)
    return response.data
  } catch (error) {
    throw error
  }
}